// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__3G7_f","file":"styles_file__NteKk"};